export const isYoutube = (url: string | undefined | null): boolean => {
  if (!url) {
    return false
  }

  const reg =
    /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube\.com|youtu.be))(\/(?:[\w\-]+\?v=|embed\/|v\/)?)([\w\-]+)(\S+)?$/

  return reg.test(url)
}

export const isVimeo = (url: string | undefined | null): boolean => {
  if (!url) {
    return false
  }

  const reg =
    /(http|https)?:\/\/(www\.|player\.)?vimeo\.com\/(?:channels\/(?:\w+\/)?|groups\/([^\/]*)\/videos\/|video\/|)(\d+)(?:|\/\?)/

  return reg.test(url)
}
